var $0cb312c2797e7a68$exports = {};
$0cb312c2797e7a68$exports = {
  "dismiss": "Dismiss",
  "alert": "Alert"
};
export { $0cb312c2797e7a68$exports as default };